import React from 'react'

const Line = () => {
  return <hr className="dreamfox-line" />
}

export default Line
